import { useSelector, useDispatch } from "react-redux"

import { MarkovState } from "server/models"
import {
    StoreType,
    setNotAssignedMarkovGroupStateSelected,
} from "client/store"
import { TableColumn } from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectState = (state: MarkovState) => {
        let selectedCopy
        if (selected && selected.includes(state.id)) {
            selectedCopy = selected.filter((id) => (id !== state.id))
        } else {
            selectedCopy = selected ? selected.slice() : []
            selectedCopy.push(state.id)
        }
        dispatch(setNotAssignedMarkovGroupStateSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            onClick: selectState,
        },
        {
            field: "description",
            header: lang.description,
            onClick: selectState,
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
            onClick: selectState,
        },
    ]

    return columns
}
export default Columns
